import { safeApiRequest } from './apiClient';

export const fetchBayiler = async ({ page = 1, limit = 20, aktif = true, search, cityId } = {}) => {
  const params = new URLSearchParams();
  params.set('sayfa', String(page));
  params.set('limit', String(limit));
  params.set('aktif', aktif ? 'true' : 'false');
  if (search && search.trim().length >= 3) params.set('arama', search.trim());
  if (cityId && cityId !== 'all') params.set('cityId', String(cityId));
  return safeApiRequest(`/api/bayiler?${params.toString()}`);
};

export const fetchBayi = async (id) => safeApiRequest(`/api/bayiler/${encodeURIComponent(id)}`);

export const updateBayiKullanici = async (id, payload) =>
  safeApiRequest(`/api/users/${encodeURIComponent(id)}`, {
    method: 'PUT',
    body: payload,
  });
